import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisExclusaoDespesasGarantias,
    obtemExclusaoDespesasGarantiasList,
} from './EstudoServiceExclusaoDespesasGarantias'

const EstudoFormExclusaoDespesasGarantias = ({ values, handleChange }) => {

    processaRegistrosDefaultIniciaisExclusaoDespesasGarantias(values)

    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <CardGridDivEntradaDados>
                    {LABEL.exclusaoDespesasGarantias}
                </CardGridDivEntradaDados>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBody>
                <FieldArray name="exclusaoDespesasGarantias">
                    {(arrayHelpers) => (
                        <DivForm>
                            <DivForm
                                style={{
                                    display: values.exclusaoDespesasGarantias && values.exclusaoDespesasGarantias.length > 0 ? "block" : "none"
                                }}
                            >
                                {values.exclusaoDespesasGarantias?.map((item, ind) => {
                                    return (
                                        <GridContainer
                                            key={ind}
                                        >
                                            <GridItem12>
                                                <GridContainer>
                                                    <GridItem11>
                                                        <TextFieldTextSelect
                                                            name={`exclusaoDespesasGarantias[${ind}].id`}
                                                            label={LABEL.despesaGarantiaASerExcluida}
                                                            value={item.id || ''}
                                                            onChange={handleChange}
                                                            list={obtemExclusaoDespesasGarantiasList(values, item.id)}
                                                        />
                                                    </GridItem11>

                                                    <GridItem1>
                                                        <IconButtonClearEntradaDados
                                                            onClick={() =>
                                                                arrayHelpers.remove(ind)
                                                            }
                                                        />
                                                    </GridItem1>
                                                </GridContainer>
                                            </GridItem12>
                                        </GridContainer>
                                    )
                                })}
                            </DivForm>

                            <GridContainer>
                                <ButtonIncluirLinha
                                    label={LABEL.buttonIncluirExclusaoReceitaDespesa} 
                                    onClick={() => 
                                        arrayHelpers.push({
                                        })
                                    }
                                />
                            </GridContainer>
                        </DivForm>
                    )}
                </FieldArray>
            </CardGridDivBody>
        </CardGridEntradaDados>
    )
}

export default EstudoFormExclusaoDespesasGarantias